import React from 'react';
import PropTypes from 'prop-types';

export function UiSwiperItem({ children, ...rest }) {
  return <swiper-slide {...rest}>{children}</swiper-slide>;
}

UiSwiperItem.propTypes = {
  children: PropTypes.node,
};
